import ApplicationController from './application_controller';

// CFS visit note form (new only): one-shot session-time auto-fill on initial load.
//   1. If start time is empty, copy the date-of-service value into it.
//   2. If end time is empty, set end = start + organization.schedule_settings.default_event_duration.
// Skip steps whose target already has a value. Runs once on connect — no change listeners,
// so manual edits after load are never touched.
//
// Mounted on the <form> element of _custom_form_new.html.erb. Locates inputs by their
// nested-attribute name pattern (visit_note[datum][<control_id>][date|start_date|end_date])
// so it works regardless of the parameterized HTML id Rails generates.
//
// Values:
//   data-vn-session-duration-date-of-service-id-value: smart-date-input control id
//   data-vn-session-duration-start-id-value:           smart-start-date-input control id
//   data-vn-session-duration-end-id-value:             smart-end-date-input control id
//   data-vn-session-duration-minutes-value:            default event duration in minutes
export default class extends ApplicationController {
  static values = {
    dateOfServiceId: String,
    startId: String,
    endId: String,
    minutes: Number,
  };

  connect() {
    const dosInput = this.dateOfServiceIdValue
      ? this.element.querySelector(`[name*="[datum][${this.dateOfServiceIdValue}][date]"]`)
      : null;
    const startInput = this.startIdValue
      ? this.element.querySelector(`[name*="[datum][${this.startIdValue}][start_date]"]`)
      : null;
    const endInput = this.endIdValue
      ? this.element.querySelector(`[name*="[datum][${this.endIdValue}][end_date]"]`)
      : null;

    // Step 1: empty start ← date of service
    if (startInput && !startInput.value && dosInput && dosInput.value) {
      startInput.value = dosInput.value;
    }

    // Step 2: empty end ← start + default duration
    if (endInput && !endInput.value && startInput && startInput.value && this.minutesValue > 0) {
      const start = new Date(startInput.value);
      if (!Number.isNaN(start.getTime())) {
        const end = new Date(start.getTime() + this.minutesValue * 60 * 1000);
        const pad = (n) => String(n).padStart(2, '0');
        // HTML datetime-local input format: YYYY-MM-DDTHH:MM
        endInput.value = `${end.getFullYear()}-${pad(end.getMonth() + 1)}-${pad(end.getDate())}T${pad(end.getHours())}:${pad(end.getMinutes())}`;
      }
    }
  }
}
